import {storeToRefs} from 'pinia';
import type {RouteLocationNormalized} from 'vue-router';
import {useAuth, useImmersionMode} from '#imports';
import {useImmersionStore} from '~/stores/immersion.store';

export const useComplianceImmersion = () => {
    const immersionStore = useImmersionStore();
    const auth = useAuth();
    const {getImmersionOwner, setImmersionFrame} = useImmersionMode();

    async function checkIfImmersionMode(to: RouteLocationNormalized) {
        // Check if we have already set immersion data
        const {identityId: identityIdFromStore} = storeToRefs(immersionStore);
        if (identityIdFromStore.value) {
            return;
        }

        const identityId = to.query.immersion as string;
        const isThisIdentityInImmersionMode = auth.isThisIdentityInImmersionMode(identityId);

        if (isThisIdentityInImmersionMode) {
            const userInImmersion = await getImmersionOwner({id: identityId, type: 'IDENTITY_ID'});
            if (userInImmersion) {
                await immersionStore.saveImmersionData(identityId, userInImmersion);
            }
        }
    }

    function setImmersionFrameIfNeeded() {
        const {identityId: identityIdFromStore, userInImmersion} = storeToRefs(immersionStore);
        if (identityIdFromStore.value) {
            setImmersionFrame(userInImmersion.value);
        }
    }

    return {
        checkIfImmersionMode,
        setImmersionFrameIfNeeded,
    };
};
